// This component displays the results for various decarbonization pathways
// for a Controlled Environment Agriculture (CEA) facility. It presents
// estimated impacts under different technology implementation scenarios and
// allows users to download the results as a CSV file.

import {numWithCommas, getRandomInt, getTimestamp, roundToSigFigs} from "../utils/utils";
import * as React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from "react-bootstrap/Button";
import {Badge} from "react-bootstrap";
import {CSVLink} from "react-csv";

// PathwaysResultsControl is a React functional component that displays
// decarbonization scenario results in a table. It provides a download
// button for exporting the results as a CSV file.
function PathwaysResultsControl(props) {
    return (
        <Accordion
            defaultActiveKey="0"
            className="control-panel-accord path-results-control-accord"
            style={{
                position: 'absolute',
                // float: 'right',
                // clear:'left',
                top: '8px',
                left: '1025px',
                width: '450px',
                // zIndex: 1000
            }}
        >
            <Accordion.Item eventKey="0"
                            // className="path-results-control-accord-expanded"
            >
                <Accordion.Header>
                    {/* The header for the accordion section. */}
                    {/*<h6>Baseline Impacts & Operational Costs</h6>*/}
                    {/*<strong className={'accord-title'}>Baseline Impacts & Operational Costs</strong>*/}
                    <span className={'accord-title'}>
                            Technology Implementation Pathways
                        </span>
                </Accordion.Header>
                <Accordion.Body
                    className={'pt-2 pathways-accordion-body'}
                    style={{
                        maxHeight: '706px',
                        overflow: 'auto',
                        overflowX: 'hidden'
                    }}
                    // style={{maxHeight: '780px', overflow: 'auto'}}
                >
                    <p style={{lineHeight: '15px'}}
                       className={'mb-1'}
                    >
                        {/* Brief description of what the pathways results represent. */}
                        The estimated impacts of the proposed CEA facility
                        under ten different efficiency strategies: </p>
                    <hr className={'mb-1'}/>

                    {/*<h6 className={'text-center'}>*/}
                    {/*    <Badge pill className={'p-1'}*/}
                    {/*           style={{'width': '100%'}}*/}
                    {/*           bg="warning">FAKE DATA</Badge>*/}
                    {/*</h6>*/}

                    {/* Table displaying the decarbonization scenario results. */}
                    <table className="table table-striped"
                        // style={{fontSize: '10px'}}
                        // className={'mt-1'}
                    >
                        <thead>
                        <tr>
                            <th className={'col-1'}>
                                Pathway
                            </th>
                            {/* Table headers for energy, water, and CO2. */}
                            {/*<th className={'col-1 text-center'}>*/}
                            <th className={'col-1'}>
                                Energy Use<br/>
                                <small
                                    style={{
                                        'fontWeight': 400, fontSize: '12px'
                                    }}>
                                    (MWh/year)
                                </small>
                            </th>
                            {/*<th scope="col" className={'col-1 text-center'}>*/}
                            <th className={'col-1'}>
                                Water Use<br/>
                                <small
                                    style={{
                                        'fontWeight': 400, fontSize: '12px'
                                    }}>
                                    (L/year)
                                </small>
                            </th>
                            {/*<th scope="col" className={'col-1 text-center'}>*/}
                            <th className={'col-1'}>
                                CO₂ Emissions
                                <br/>
                                <small
                                    style={{
                                        'fontWeight': 400, fontSize: '12px'
                                    }}>
                                    (kg/year)
                                </small>
                            </th>
                            {/*<th scope="col" className={'col-1 text-center'}>*/}
                            {/*<th className={'col-1'}>*/}
                            {/*    Cost <br/>*/}
                            {/*    <small*/}
                            {/*        style={{*/}
                            {/*            'fontWeight': 400, fontSize: '12px'*/}
                            {/*        }}>*/}
                            {/*        $/lb product*/}
                            {/*    </small>*/}
                            {/*</th>*/}
                        </tr>
                        </thead>
                        <tbody>
                        {/* Iterate over each pathway result and display its metrics. */}
                        {props.pathwaysResults.map((x) => (
                                <tr key={x.id}>
                                    <th
                                        style={{lineHeight: '16px'}}
                                        scope="row"
                                    >
                                        {x['Pathway']}
                                    </th>
                                    {/* Display energy use as a single value or a range. */}
                                    {
                                        roundToSigFigs(
                                            x['Annual Energy Consumption (MWh/year) Min']) ===
                                        roundToSigFigs(x['Annual Energy Consumption (MWh/year) Max']) ?
                                            <td>
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['Annual Energy Consumption (MWh/year) Min']
                                                    )
                                                )}
                                            </td>
                                            :
                                            <td>
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['Annual Energy Consumption (MWh/year) Min']
                                                    )
                                                )}
                                                {' - '}
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['Annual Energy Consumption (MWh/year) Max']
                                                    )
                                                )}
                                            </td>
                                    }
                                    {/* Display water use as a single value or a range. */}
                                    <td>
                                    {
                                        roundToSigFigs(x['Water Use (L/year) Min']) ===
                                        roundToSigFigs(x['Water Use (L/year) Max']) ?
                                            <td>
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['Annual Water Consumption (L/year) Min']
                                                    )
                                                )}
                                            </td>
                                            :
                                            <td>
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['Annual Water Consumption (L/year) Min']
                                                    )
                                                )}
                                                {' - '}
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['Annual Water Consumption (L/year) Max']
                                                    )
                                                )}
                                            </td>
                                    }
                                    </td>
                                    {/* Display CO2 emissions as a single value or a range. */}
                                    <td>
                                    {
                                        roundToSigFigs(x['CO2 emissions (kg/year) Min']) ===
                                        roundToSigFigs(x['CO2 emissions (kg/year) Max']) ?
                                            <td>
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['CO2 emissions (kg/year) Min']
                                                    )
                                                )}
                                            </td>
                                            :
                                            <td>
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['CO2 emissions (kg/year) Min']
                                                    )
                                                )}
                                                {' - '}
                                                {numWithCommas(
                                                    roundToSigFigs(
                                                        x['CO2 emissions (kg/year) Max']
                                                    )
                                                )}
                                            </td>
                                    }
                                    </td>
                                </tr>
                            )
                        )
                        }
                        </tbody>
                    </table>
                    <div className={'text-center'}>
                        {/* Button to download the pathways results as a CSV file. */}
                        <CSVLink
                            data={props.pathwaysResults}
                            target="_blank"
                            style={{width: '45%'}}
                            filename={
                                `cea_decarbonization_pathways_${getTimestamp()}.csv`
                            }
                        >
                            <Button variant="outline-secondary"
                                    className={'p-1 mb-2'}
                                    style={{fontSize: '14px', width: '100%'}}
                            >
                                <p
                                    // style={{lineHeight: '16px'}}
                                    className={'m-0'}>
                                    Download Results
                                </p>
                            </Button>
                        </CSVLink>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}

export default React.memo(PathwaysResultsControl);
